import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ArticleCard from "../common/articleCard/ArticleCard.common";
import { NoDataUI } from "../common/noDataUI/noDataUI.common";
import Title from "../common/title/Title.common";
import CompWrapper from "../hoc/compWrapper/CompWrapper.hoc";
import ActivityIndicator from "../hoc/activityIndicator/ActivityIndicator.hoc";

// ACTIONs
import { getPublicationAction } from "../../actions/Actions";

const PublicationPage = (props) => {
  const { setHeaderTitle, language, researchProgram } = useAuth();
  const { getPublicationAction, publication } = props;
  const { listLoader, list } = publication;

  // console.log("publication", publication);

  useEffect(() => {
    setHeaderTitle(language.key.publication);
  }, [setHeaderTitle, language.key.publication]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getPublicationAction(researchProgram?.id);
  }, [getPublicationAction, researchProgram]);

  return (
    <CompWrapper>
      <Title title={language.key.publication} hide_SeeAll />
      <ActivityIndicator animating={listLoader}>
        {list.length > 0 ? (
          <div className="news-container">
            {list.map((val, index) => {
              return (
                <div key={index}>
                  <ArticleCard data={val} />
                </div>
              );
            })}
          </div>
        ) : <NoDataUI />}
      </ActivityIndicator>
    </CompWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    publication: state.publication,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPublicationAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationPage);
